import { DatePipe } from '@angular/common';
import { constants } from './constants';

export class Utilities {

    static getStringXSSEncoded(text:string){
        var lt = /</g, gt = />/g, ap = /'/g, ic = /"/g;
        return text.toString().replace(lt, "&lt;").replace(gt, "&gt;").replace(ap, "&#39;").replace(ic, "&#34;");
    }
    static getCurrentMonthWord(){
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'MMMM yyyy');
    }

    static getFirstOfCurrentMonth() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    }

    static getLastOfCurrentMonth() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    }

    static getFirstOfLastMonth() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth()-1, 1), 'yyyy-MM-dd');
    }

    static getLastOfLastMonth() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 0), 'yyyy-MM-dd');
    }

    static get12MonthsAgo() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setMonth(date.getMonth() - 12);
        return datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    }

    static get6MonthsAgo() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setMonth(date.getMonth() - 6);
        return datepipe.transform(date, 'yyyy-MM-dd');
    }

    static get3MonthsAgo() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setMonth(date.getMonth() - 3);
        return datepipe.transform(date, 'yyyy-MM-dd');
    }
    
    static get1MonthAgo() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setMonth(date.getMonth() - 1);
        return datepipe.transform(date, 'yyyy-MM-dd');
    }
  
    static getToday() {
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setDate(date.getDate() + 1);
        return datepipe.transform(date, 'yyyy-MM-dd');
    }

    static getTodayMinusDays(days: number){
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setDate(date.getDate() - days);
        return datepipe.transform(date, 'yyyy-MM-dd');
    } 
    
    static getTodayPlusDays(days: number){
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date.setDate(date.getDate() + days);
        return datepipe.transform(date, 'yyyy-MM-dd');
    }
    static getPreviousMonthStart(){
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date = new Date(date.getFullYear(), date.getMonth()-2, 1);
       
        return datepipe.transform(date, 'yyyy-MM-dd');
    }

    
    static getPreviousMonthLast(){
        const datepipe: DatePipe = new DatePipe('en-GB')
        var date = new Date();
        date = new Date(date.getFullYear(), date.getMonth()-2, new Date(date.getFullYear(), date.getMonth() -1, 0).getDate());
        return datepipe.transform(date, 'yyyy-MM-dd');
    }

    static getDateAsString(date: Date) {
        const datepipe: DatePipe = new DatePipe('en-GB')
        return datepipe.transform(date, "yyyy-MM-dd");
    }

    static checkTruePositive(caseNumber: string, status: string, closureCode: string){
        return ((!caseNumber.startsWith("OCD") && constants.incidentStatus.truepositive.includes(status)) || constants.incidentStatus.truepositive.includes(closureCode))
    }

    static checkFalsePositive(status: string, closureCode: string){
        return (constants.incidentStatus.falsepositive.includes(status) || constants.incidentStatus.falsepositive.includes(closureCode))
    }

}